var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("create-bookkeeping-data"))),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "6" } },
                    [
                      _c("app-month-select", {
                        attrs: {
                          "use-bookyear-start": "",
                          label: _vm.$ct("common.from"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.dateRange.startMonth,
                          callback: function ($$v) {
                            _vm.$set(_vm.dateRange, "startMonth", $$v)
                          },
                          expression: "dateRange.startMonth",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "6" } },
                    [
                      _c("app-month-select", {
                        attrs: {
                          "use-bookyear-start": "",
                          label: _vm.$ct("common.till"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.dateRange.endMonth,
                          callback: function ($$v) {
                            _vm.$set(_vm.dateRange, "endMonth", $$v)
                          },
                          expression: "dateRange.endMonth",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.start()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }